import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const RecipeMacros = ({ macro }) => {
  return (
    <div className="Row">
      <FontAwesomeIcon width={7} color={macro?.color} icon={faCircle} />
      <p className="Small-Font marg-0">
        {macro?.grams}g {macro?.label}
      </p>
    </div>
  );
};

export default RecipeMacros;
